import { IRGBA } from './Color';

export function isRgbaEqual(lhs: IRGBA, rhs: IRGBA): boolean {
  if (!lhs || !rhs) {
    return false;
  }
  return lhs.r === rhs.r && lhs.g === rhs.g && lhs.b === rhs.b && lhs.a === rhs.a;
}
